import React from "react";
import { AuthorityDocumentsPanel } from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";

export function DocumentsPreuvesDocumentsPage() {
  return (
    <div data-testid="page-admin-documents-preuves-documents">
      <AuthorityDocumentsPanel mode="admin" scope="all" testId="documents-preuves-documents-panel" />
    </div>
  );
}
